import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appClimateIconClass',
})
export class ClimateIconClassPipe implements PipeTransform {
  private readonly classes: Record<string, string> = {
    temperature: 'icon-temp',
    humidity: 'icon-humidity',
    co2: 'icon-co2',
    windSpeed: 'icon-wind',
  };

  public transform(type: string): string {
    return this.classes[type] || '';
  }
}
